import { useMutation } from '@tanstack/react-query';
import { useExerciseStore } from '../stores/exercisesStore';
import { getExercises } from '../queries/exercises';

type IBody = { module: string; operation: string; page: number };

export function useNewExerciseHook() {
  const setExercise = useExerciseStore.getState().setExercises;

  const { isPending, mutate, data } = useMutation({
    mutationKey: ['exercises-discipline'],
    mutationFn: ({ module, operation, page }: IBody) =>
      getExercises(module, operation, page),
    retry: false,
    onSuccess: (result) => {
      setExercise(result.returnedData);
    },
  });

  return { isPending, mutate, hasMore: data?.hasMore ?? false };
}
